// packages/web-ui/src/AppShell/ContextPanel-modes/SettingsCollapsed.tsx
//
// W2-S3 Task 7.6 — Settings destination collapses the panel to 0 px width.
// The collapse is driven by the `<ContextPanel>` parent (which zeroes
// `style.width`); this component renders a hidden `data-testid` marker so
// harness queries succeed deterministically.

import type { JSX } from 'react';

export function SettingsCollapsed(): JSX.Element {
  return (
    <div
      data-testid="settings-mode-root"
      aria-hidden="true"
      className="sr-only"
    />
  );
}
